export default {
  all: [
    {
      id: 1,
      createdAt: '01/01/2000',
      modifiedAt: '01/01/2000',
      subscriberId: 1,
      dealerId: 1,
      userId: 1,
      supplierId: 1,
      customerId: 1,
      toEmailAddresses: '',
      toMobileNumbers: '',
      subject: '',
      content: '',
      recipientType: '',
      fileLocation: 'Test Service Video',
      status: 'Active',
      createdBy: 1,
      modifiedBy: 1
    }
  ]
}
